import React  from "react";

import { useDispatch,useSelector } from 'react-redux';
const ExtraSmallCard =() =>{
   
      const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
    
return <>
            <div     className={`${mainMenuStatus?"item-card-nav":"item-card-nav-small"}  add-cursor`} style={{height:"40px"}}  >
            <div  className="item-icon"> </div>
            {/* <div  className="item-text">
            <div className="text-line-extra-small-card "></div> 
            </div>   */}
            
             </div>  
             
              
              
              
              
              
              
              </>
}

export default ExtraSmallCard;